import { useState, useLayoutEffect } from "react";
import { Button } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";

export const UpButton = () => {
    const [isScrolledFar, setFarScrolled] = useState(false);

    useLayoutEffect(() => {
        const handleScroll = () => {
            setFarScrolled(window.scrollY >= window.innerHeight * 2);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <Button
            sx={{
                position: "fixed",
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                bottom: "5vh",
                right: { xs: "5vw", lmd: "2vw" },
                zIndex: 20,
                minWidth: "unset",
                backgroundColor: "brandColors.brandGreen",
                color: "#fff",
                transition: ".15s",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                opacity: isScrolledFar ? 1 : 0,
                pointerEvents: isScrolledFar ? "auto" : "none",
                "&:hover": {
                    backgroundColor: "brandColors.brandGreenDark",
                },
                "& svg": {
                    width: "32px",
                    height: "32px",
                },
            }}
            onClick={handleClick}
        >
            <ArrowUpwardRoundedIcon color="inherit" />
        </Button>
    );
};
